module.exports = __webpack_public_path__ + "static/img/2_03.6fa41829.png";